import { useTranslation } from 'next-i18next';
import Skeleton from 'react-loading-skeleton';

import styles from './OutfittingTile.module.scss';

const SKELETON_ROWS = ['row-1', 'row-2', 'row-3'];

const LoadingSkeleton = () => {
  const { t } = useTranslation('common');

  return (
    <section
      className={styles.root}
      aria-label={t('outfitting.sectionAriaLabel')}
      aria-busy="true"
    >
      <div className={styles.tile}>
        <div className={styles.info} aria-hidden="true">
          <Skeleton className={styles.skeletonHeading} />
          <Skeleton count={2} />
          <Skeleton width="45%" />
        </div>

        <div className={styles.media}>
          <Skeleton className={styles.skeletonImage} aria-hidden="true" />

          <div className={styles.cards}>
            <div className={styles.skeletonCard} aria-hidden="true">
              {SKELETON_ROWS.map((rowKey) => (
                <div key={rowKey} className={styles.skeletonRow}>
                  <Skeleton className={styles.skeletonThumb} />
                  <span className={styles.skeletonLines}>
                    <Skeleton />
                    <Skeleton width="40%" />
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <span className={styles.visuallyHidden} role="status">
        {t('outfitting.loading')}
      </span>
    </section>
  );
};

export default LoadingSkeleton;
